import { useParams } from 'react-router-dom';

import { DocChronologiesTable } from './components/doc-chronologies-table';
import { useGetMatterV2 } from '@/api/queries/useGetMatterV2';
import { useGetSubset } from '@/api/queries/useGetSubset';
import { Breadcrumb } from '@/new/components/breadcrumb';
import { PageContainer } from '@/new/components/page-container';
import { PageHeader } from '@/new/components/page-header';
import { PageTitle } from '@/new/components/page-title';
import { SubsetChip } from '@/new/components/subset-chip';
import { useSubsetBreadcrumbs } from '@/new/hooks/use-subset-breadcrumbs';

export function DocChronologies() {
  const { matterId, subsetId } = useParams();
  if (!matterId || !subsetId) return null;

  const { data: matter } = useGetMatterV2(matterId);
  const { data: subset } = useGetSubset(matterId, subsetId);

  const breadcrumbItems = useSubsetBreadcrumbs({
    matterId,
    subsetId,
    matter,
    subset,
    currentPage: { label: 'Doc Chronologies', path: 'chronologies/doc' },
  });

  return (
    <>
      <Breadcrumb items={breadcrumbItems} />

      <PageContainer>
        <PageHeader>
          <div className="flex items-center gap-4">
            <PageTitle text="Doc Chronologies" />
            <SubsetChip subsetId={subsetId} className="mt-0.5" />
          </div>
        </PageHeader>
      </PageContainer>

      <DocChronologiesTable />
    </>
  );
}
